import React from 'react';
import { Link, Typography } from '@hpstellar/core/visId';
import { ChevronLeft } from '@hpstellar/icons';

const QuestionCard = ({ totalQ, currentQ, title, question, onClick, goBack }) => {
    const { answers, image, question: questionText } = question || {};

    return (
        <>
            <div className="question-dashboard">
                <div className="image-container">
                    {image && <img className="question-image" src={image} alt="question" />}
                </div>
                <div className="question-content">
                    <Typography className="questionnaire-title" tag="h2">
                        {title}
                    </Typography>
                    {questionText && (
                        <div className="questionRow">
                            <Typography tag="h3" className="question-text">
                                {questionText}
                            </Typography>
                            <Typography tag="h3" className="question-counter">
                                Question {currentQ + 1} of {totalQ}
                            </Typography>
                        </div>
                    )}
                    <div className="answer-list">
                        {answers.map((answer, index) => {
                            const { title, text, icon, filter } = answer || {};
                            return (
                                <div
                                    className={`answer-card ${!icon ? 'centered' : ''}`}
                                    onClick={() => onClick(answer)}
                                    key={title}
                                >
                                    {/* icon can be image src or svg*/}
                                    {icon && <img className="answer-icon" src={icon} alt={title} />}
                                    <div className="answer-section">
                                        {title && (
                                            <Typography tag="h4" className="answer-title">
                                                {title}
                                            </Typography>
                                        )}
                                        {text && <Typography className="answer-text">{text}</Typography>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="navigation-buttons">
                        {currentQ > 0 && (
                            <Link className="goBackButton" onClick={goBack}>
                                <ChevronLeft className="iconLeft" size="s" />
                                Back
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuestionCard;
